/* src/routes/blog/test-private-methods.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Gallery from "../../../_components/Gallery.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";
import Link from "../../../_components/Link.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";

function create_default_slot_3(ctx) {
	let t0;
	let prism0;
	let t1;
	let br0;
	let br1;
	let t2;
	let prism1;
	let t3;
	let prism2;
	let current;

	prism0 = new Prism({
			props: {
				language: "csharp",
				inline: true,
				code: `RunPrivateMethod()`
			}
		});

	prism1 = new Prism({
			props: {
				language: "csharp",
				code: `public static class TestHelpers
{
    public static object RunPrivateMethod(this object obj, string methodName, params object[] args)
    {
        var method = obj
            .GetType()
            .GetMethod(methodName, BindingFlags.NonPublic | BindingFlags.Instance);
        if (method == null)
        {
            throw new ArgumentException(
                $"{obj.GetType()} does not contain the method {methodName}", 
                "methodName"
            );
        }
        return method.Invoke(obj, args);
    }
}`
			}
		});

	prism2 = new Prism({
			props: {
				language: "csharp",
				code: `var res1 = obj.RunPrivateMethod("SecretInternalMethod");
var res2 = obj.RunPrivateMethod("SecretInternalMethodWithArgs", arg1, arg2);`
			}
		});

	return {
		c() {
			t0 = text("This extension will allow any object to invoke a private method ");
			create_component(prism0.$$.fragment);
			t1 = text(".\n    ");
			br0 = element("br");
			br1 = element("br");
			t2 = space();
			create_component(prism1.$$.fragment);
			t3 = text("\nUse it like this\n");
			create_component(prism2.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "This extension will allow any object to invoke a private method ");
			claim_component(prism0.$$.fragment, nodes);
			t1 = claim_text(nodes, ".\n    ");
			br0 = claim_element(nodes, "BR", {});
			br1 = claim_element(nodes, "BR", {});
			t2 = claim_space(nodes);
			claim_component(prism1.$$.fragment, nodes);
			t3 = claim_text(nodes, "\nUse it like this\n");
			claim_component(prism2.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(prism0, target, anchor);
			insert(target, t1, anchor);
			insert(target, br0, anchor);
			insert(target, br1, anchor);
			insert(target, t2, anchor);
			mount_component(prism1, target, anchor);
			insert(target, t3, anchor);
			mount_component(prism2, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(prism0.$$.fragment, local);
			transition_in(prism1.$$.fragment, local);
			transition_in(prism2.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism0.$$.fragment, local);
			transition_out(prism1.$$.fragment, local);
			transition_out(prism2.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(prism0, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(br0);
			if (detaching) detach(br1);
			if (detaching) detach(t2);
			destroy_component(prism1, detaching);
			if (detaching) detach(t3);
			destroy_component(prism2, detaching);
		}
	};
}

// (51:0) <PostSection title="Explanation">
function create_default_slot_2(ctx) {
	let t0;
	let prism0;
	let t1;
	let prism1;
	let t2;
	let br0;
	let br1;
	let t3;
	let prism2;
	let t4;
	let prism3;
	let current;

	prism0 = new Prism({
			props: {
				language: "csharp",
				inline: true,
				code: `BindingFlags.NonPublic | BindingFlags.Instance`
			}
		});

	prism1 = new Prism({
			props: {
				language: "csharp",
				inline: true,
				code: `MethodInfo`
			}
		});

	prism2 = new Prism({
			props: {
				language: "csharp",
				inline: true,
				code: `using System;`
			}
		});

	prism3 = new Prism({
			props: {
				language: "csharp",
				inline: true,
				code: `using System.Reflection;`
			}
		});

	return {
		c() {
			t0 = text("The magic happens mainly with ");
			create_component(prism0.$$.fragment);
			t1 = text(" \nwhich allows us to use reflection to get the ");
			create_component(prism1.$$.fragment);
			t2 = text(" for the specified private method.\n\n");
			br0 = element("br");
			br1 = element("br");
			t3 = text("\nDon't forget to include using statemnets ");
			create_component(prism2.$$.fragment);
			t4 = text(" and ");
			create_component(prism3.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "The magic happens mainly with ");
			claim_component(prism0.$$.fragment, nodes);
			t1 = claim_text(nodes, " \nwhich allows us to use reflection to get the ");
			claim_component(prism1.$$.fragment, nodes);
			t2 = claim_text(nodes, " for the specified private method.\n\n");
			br0 = claim_element(nodes, "BR", {});
			br1 = claim_element(nodes, "BR", {});
			t3 = claim_text(nodes, "\nDon't forget to include using statemnets ");
			claim_component(prism2.$$.fragment, nodes);
			t4 = claim_text(nodes, " and ");
			claim_component(prism3.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(prism0, target, anchor);
			insert(target, t1, anchor);
			mount_component(prism1, target, anchor);
			insert(target, t2, anchor);
			insert(target, br0, anchor);
			insert(target, br1, anchor);
			insert(target, t3, anchor);
			mount_component(prism2, target, anchor);
			insert(target, t4, anchor);
			mount_component(prism3, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(prism0.$$.fragment, local);
			transition_in(prism1.$$.fragment, local);
			transition_in(prism2.$$.fragment, local);
			transition_in(prism3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism0.$$.fragment, local);
			transition_out(prism1.$$.fragment, local);
			transition_out(prism2.$$.fragment, local);
			transition_out(prism3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(prism0, detaching);
			if (detaching) detach(t1);
			destroy_component(prism1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(br0);
			if (detaching) detach(br1);
			if (detaching) detach(t3);
			destroy_component(prism2, detaching);
			if (detaching) detach(t4);
			destroy_component(prism3, detaching);
		}
	};
}

// (60:0) <PostSection title="Usage">
function create_default_slot_1(ctx) {
	let t;
	let prism;
	let current;

	prism = new Prism({
			props: {
				language: "csharp",
				code: `public class Person
{
    public string FirstName { get; set; }
    public string LastName { get; set; }

    private string GetFullName() // <-- Private Method
    {
        return $"{FirstName} {LastName}";
    }

    private string GetFullNameWithNickname(string nickname) // <-- Private Method with argument
    {
        return $"{FirstName} '{nickname}' {LastName}";
    }
}

[Fact]
public void GetFullName__Should_Return_ExpectedResult()
{
    // ARRANGE
    var test = new Person { FirstName = "Ace", LastName = "Rimmer" };

    // ACT
    var name = test.RunPrivateMethod("GetFullName"); // <-- without args
    var nickname = test.RunPrivateMethod("GetFullNameWithNickname", "what a guy!"); // <-- with args
    
    // ASSERT
    name.Should().Be("Ace Rimmer");
    nickname.Should().Be("Ace 'what a guy!' Rimmer");
}`
			}
		});

	return {
		c() {
			t = text("The following usage example shows how this could be used in a unit test\n\n");
			create_component(prism.$$.fragment);
		},
		l(nodes) {
			t = claim_text(nodes, "The following usage example shows how this could be used in a unit test\n\n");
			claim_component(prism.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t, anchor);
			mount_component(prism, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(prism.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t);
			destroy_component(prism, detaching);
		}
	};
}

// (18:0) <PostContents>
function create_default_slot(ctx) {
	let postsection0;
	let t0;
	let postsection1;
	let t1;
	let postsection2;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "TL;DR",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Explanation",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	postsection2 = new PostSection({
			props: {
				title: "Usage",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection0.$$.fragment);
			t0 = space();
			create_component(postsection1.$$.fragment);
			t1 = space();
			create_component(postsection2.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(postsection2.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection0, target, anchor);
			insert(target, t0, anchor);
			mount_component(postsection1, target, anchor);
			insert(target, t1, anchor);
			mount_component(postsection2, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
			const postsection2_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection2_changes.$$scope = { dirty, ctx };
			}

			postsection2.$set(postsection2_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			transition_in(postsection2.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			transition_out(postsection2.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection0, detaching);
			if (detaching) detach(t0);
			destroy_component(postsection1, detaching);
			if (detaching) detach(t1);
			destroy_component(postsection2, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "Test Private Methods with C#";
const date = "2021-02-14";

function instance($$self) {
	const tags = ["unit test", "c-sharp"];
	const projects = [];
	return [tags, projects];
}

class Test_private_methods extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Test_private_methods;
//# sourceMappingURL=test-private-methods.svelte.js.map
